import type { CurvePath, Group, Object3D, Vector3 } from '@anov/3d-core'

export interface BatchInterface {
  path: CurvePath<Vector3>
  number: number
  span: number
  followTangent: boolean
}

export type Option = {
  path: CurvePath<Vector3>
  number?: number
  span?: number
  followTangent?: boolean
  entity: Object3D
}